// Captures the PWA install opportunity as EARLY as possible. `beforeinstallprompt`
// can fire before React mounts, so we listen at module load (imported in index.js)
// and stash the event for the UI to use whenever the user is ready.
let deferred = null;
const subs = new Set();
const notify = () => subs.forEach((f) => f());

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferred = e;
    notify();
  });
  window.addEventListener("appinstalled", () => {
    deferred = null;
    notify();
  });
}

export const installStore = {
  get: () => deferred,
  clear: () => { deferred = null; notify(); },
  subscribe: (f) => { subs.add(f); return () => subs.delete(f); },
};

// Ask the UI (InstallPrompt) to open, regardless of any previous dismissal.
export const openInstallPopup = () => {
  if (typeof window !== "undefined") window.dispatchEvent(new Event("pmx-open-install"));
};
